import React, { Component } from 'react'
import './App.css'

// import Header from 'components/common/header/index.js'
import Header from 'components/common/header_v2/index.js'
import Footer from 'components/common/footer/index.js'

import Routes from 'routes'
import Chatbot from 'features/chatbot/index.js'
import { CircleArrow as ScrollUpButton } from 'components/back-to-top'

class App extends Component {
    render() {
        return (
            <div className="app">
                <Header />
                <Routes />
                <Chatbot />
                <Footer />
                <ScrollUpButton />
            </div>
        )
    }
}

export default App
